export enum UserRole {
  User = "User",
  Admin = "Admin",
  SuperAdmin = "SuperAdmin",
}

const ROLE_HIERARCHY: UserRole[] = [UserRole.User, UserRole.Admin, UserRole.SuperAdmin];

export const hasRequiredRole = (
  userRole: UserRole | undefined,
  requiredRoles: readonly UserRole[]
): boolean => {
  if (!userRole) {
    return false;
  }

  const userRoleIdx = ROLE_HIERARCHY.indexOf(userRole);
  const lowestRequiredRoleIdx = requiredRoles.reduce((lowestIdx, role) => {
    const idx = ROLE_HIERARCHY.indexOf(role);
    return idx < lowestIdx ? idx : lowestIdx;
  }, Number.POSITIVE_INFINITY);

  return userRoleIdx >= lowestRequiredRoleIdx;
};
